/**
 * Defines UI State interface
 */
export interface UIState {
    ui_sidebar_open: boolean;
}

/**
 * Defines UI actions names
 */
export const UI_SET_SIDEBAR_STATE = 'UI_SET_SIDEBAR_STATE';

/**
 * Defines UI actions interfaces
 */
interface UISetSidebarStateAction {
    type: typeof UI_SET_SIDEBAR_STATE;
    sideBarState: boolean;
}

/**
 * Defines all suported actions for UI
 */
export type UIActionTypes = 
    UISetSidebarStateAction;

/**
 * Defines UIActionsInterface
 */
export interface UIActionsInterface {
    uiToggleSideBarState: () => boolean;
}
